import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./Listing.css";
import ListingSlider from "../Slider/ListingSlider";
// import ListingSliderSM from "../Slider/ListingSliderSM";
import { useGetCarsFilterTabQuery } from "../../redux/createApi";

const Listing = () => {
  const [tabs, setTabs] = useState("Automobile");

  const { data } = useGetCarsFilterTabQuery({
    page: 1,
    size: 10,
    vehicle_type: tabs,
  });

  const handleTabChange = (selectedTab) => {
    if (selectedTab === "Vehicles") {
      setTabs("Automobile");
    } else {
      setTabs(selectedTab);
    }
  };

  return (
    <div className="bg py-2">
      <div className="row mt-5 d-lg-block d-none">
        <div className="col-lg-6 mx-auto">
          <div className="site-heading text-center">
            <span className="site-title-tagline">
              <i className="flaticon-drive"></i> Popular Vehicle
            </span>
            <div className="heading-divider"></div>
          </div>
        </div>
      </div>

      <div className="container mb-4">
        <Tabs
          activeKey={tabs === "Automobile" ? "Vehicles" : tabs}
          onSelect={handleTabChange}
          id="vehicle-tabs"
          className="mb-3"
        >
          {/* <Tab eventKey="Bikes" title="Bikes" disabled>
            <div className="d-lg-block d-none">
              <ListingSlider data={data?.data} />
            </div>
            <div className="d-lg-none s-sm-block">
              <ListingSliderSM data={data?.data} />
            </div>
          </Tab> */}
          {/* d-lg-block d-none */}
          <Tab eventKey="Boat" title="Boat">
            <div className="">
              <ListingSlider data={data?.data} />
            </div>
            {/* <div className="d-lg-none s-sm-block">
              <ListingSliderSM data={data?.data} />
            </div> */}
          </Tab>
          <Tab eventKey="ATV" title="ATV">
            <div className="">
              <ListingSlider data={data?.data} />
            </div>
            {/* <div className="d-lg-none s-sm-block">
              <ListingSliderSM data={data?.data} />
            </div> */}
          </Tab>
          <Tab eventKey="Vehicles" title="Vehicles">
            <div className="">
              <ListingSlider data={data?.data} />
            </div>
            {/* <div className="d-lg-none s-sm-block">
              <ListingSliderSM data={data?.data} />
            </div> */}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Listing;
